export const AUTH_APP_VERSION = 'v1.18.3';

export const AUTH_LEGAL_NOTICE =
  '© 2026 EXREG · EXREG® is a registered trademark of LBVsolutions d.o.o · EUIPO 019192844';
